






























































































































import Vue from "vue";
import moment from "moment";

// Model
import { Machine } from "@/model/data/Machine";
import { getImageFromModel_200, getInstallationPredictedStatusIconColor, MODULE_COLORS } from "@/utility/Constants";
import { GetLastMachinePredictedStatusCommand, GetLastMachinePredictedStatusReqData } from "@/model/communication/predictiveMaintenance/GetLastMachinePredictedStatusCommand";
import { GetLastMachinePredictedStatusResData } from "@/model/communication/predictiveMaintenance/GetLastMachinePredictedStatusResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { Prediction } from "@/model/data/predictiveMaintenance/Prediction";
import { mapGetters } from "vuex";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    props: {
        machine: { type: Machine, required: true },
        machinePredictedStatus: Prediction,
        firstPredictionDateTime: String,
    },
    data() {
        return {
            ClientPrivileges,
            MODULE_COLORS,
            loading: false,
            dateListString: [],
            seriesList: [],
            endDate: null,
            startDate: null,
            weeks: this.$t("predictiveMaintenance.evaluating"),
        };
    },
    computed: {
        ...mapGetters(["userDateFormat", "authUserHasPrivilege"]),

        chartPredictionTrend() {
            return {
                options: {
                    chart: {
                        type: "line",
                        stacked: false,
                        zoom: {
                            enabled: true,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"],
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                    },
                    yaxis: {
                        max: 100,
                        min: 0,
                        labels: {
                            formatter: (value) => (value != null ? value.toFixed(0) + "%" : null),
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => (value != null ? value.toFixed(0) + "%" : null),
                        },
                    },
                    colors: ["#008FFB", "#C62828"],
                },
                series: this.seriesList,
            };
        },
        chartFIPie() {
            return {
                options: {
                    series: Array.from(this.pieLabelValue.values()),
                    chart: {
                        type: "pie",
                        animations: {
                            enabled: false,
                        },
                    },
                    legend: {
                        show: true,
                        position: "bottom",
                        verticalAlign: "bottom",
                        align: "center",
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => "",
                            title: {
                                formatter: (value) => value,
                            },
                        },
                    },
                    labels: Array.from(this.pieLabelValue.keys()),
                },
            };
        },
        pieLabelValue() {
            let pieLabelValue = new Map<string, number>();
            if (this.machinePredictedStatus.importantFeature != null) {
                let label = "";
                Array.from(this.machinePredictedStatus.importantFeature.keys()).forEach((key: string) => {
                    let keySplitted = key.split(" ");
                    if (["STDC", "ACL", "ACT"].includes(keySplitted[0])) {
                        label = this.$t("predictiveMaintenance." + keySplitted[0], { num: keySplitted.slice(1).join(" ") });
                    } else if (["Min", "Max", "Mean"].includes(keySplitted[0]))
                        label = this.$t("predictiveMaintenance.exception", {
                            num: parseInt(keySplitted[3]).toString(16).padStart(3, "0").toUpperCase(),
                        });
                    else if (keySplitted[0] == "Exception")
                        label = this.$t("predictiveMaintenance.exception", {
                            num: keySplitted.slice(1).join(" "),
                        });
                    else if (keySplitted[0] == "RC") {
                        label = this.$t("predictiveMaintenance.reject", { cause: keySplitted[1] });
                    } else if (keySplitted[0] == "MTBF") label = this.$t("predictiveMaintenance.MTBF");
                    else if (["Deposited", "Withdrawn"].includes(keySplitted[0])) label = this.$t("predictiveMaintenance." + keySplitted[0].toLowerCase());
                    if (pieLabelValue.has(label)) pieLabelValue.set(label, pieLabelValue.get(label) + this.machinePredictedStatus.importantFeature.get(key));
                    else pieLabelValue.set(label, this.machinePredictedStatus.importantFeature.get(key));
                });
            }
            return pieLabelValue;
        },
    },
    created() {
        this.computeStartEndDate();
        this.getPreditions();
    },
    methods: {
        getImageFromModel_200,
        getInstallationPredictedStatusIconColor,
        formatDate: function (date) {
            if (this.userDateFormat == null || this.userDateFormat == undefined) return date;
            return moment(date).format(this.userDateFormat);
        },
        goToLogTab() {
            this.$emit("to-log");
        },
        async getPreditions() {
            try {
                let today = new Date();
                let endDate = moment.utc(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`, "YYYY-MM-DD").toDate();
                this.loading = true;
                let reqData = new GetLastMachinePredictedStatusReqData(this.machine.installationName, this.machine.serialNumber, 10, endDate);
                let response: GetLastMachinePredictedStatusResData = await new GetLastMachinePredictedStatusCommand(reqData).execute();
                this.loading = false;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.predictions) {
                    let flag = true;
                    if (response.predictions.length > 0) {
                        this.seriesList = [
                            { name: this.$t("predictiveMaintenance.failureProbability"), data: new Array<number>(10).fill(null) },
                            { name: this.$t("predictiveMaintenance.warningThreshold"), data: new Array<number>(10).fill(response.probabilityWarningThreshold) },
                        ];
                        response.predictions.forEach((prediction) => {
                            if (prediction.status && flag) {
                                let diffDays = Math.ceil((endDate.getTime() - prediction.dateTime.getTime()) / (1000 * 60 * 60 * 24));
                                if (Math.ceil(3 - diffDays / 7) > 0) this.weeks = this.$t("predictiveMaintenance." + Math.ceil(3 - diffDays / 7).toString());
                                else this.weeks = this.$t("predictiveMaintenance.days");
                                flag = false;
                            }
                            let dayIndex = Math.floor((prediction.dateTime.getTime() - this.startDate.getTime()) / (1000 * 3600 * 24));
                            this.seriesList[0].data[dayIndex] = prediction.confidence;
                        });
                    }
                    if (this.machinePredictedStatus && this.machinePredictedStatus.status && flag) {
                        let diffDays = Math.ceil((endDate.getTime() - this.machinePredictedStatus.dateTime.getTime()) / (1000 * 60 * 60 * 24));
                        if (Math.ceil(3 - diffDays / 7) > 0) this.weeks = this.$t("predictiveMaintenance." + Math.ceil(3 - diffDays / 7).toString());
                        else this.weeks = this.$t("predictiveMaintenance.days");
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending GetLastMachinePredictedStatusCommand request ", e);
            }
        },
        computeStartEndDate() {
            this.endDate = new Date();
            this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), 0, 0, 0);
            this.startDate = this.addDays(this.endDate, -9);
            let dateList = [];
            for (let i = 0; i < 10; i++) dateList.push(this.addDays(this.startDate, i));
            dateList.forEach((date) => {
                this.dateListString.push(moment(date).format(this.userDateFormat));
            });
        },
        addDays(date: Date, days: number) {
            let newDate = new Date(date);
            newDate.setDate(date.getDate() + days);
            return newDate;
        },
    },
});
